import React, { Component } from 'react';
import PropTypes from 'prop-types';

const DEFAULT_FALLBACK_SRC = 'https://static.100r.systems/img/general/no-image.jpg';
const TRANSPARENT_SRC = 'https://static.100r.systems/img/general/blank.gif';


export default class ImageWithFallback extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: 'LOADING',
    };
  }

  componentWillReceiveProps(nextProps) {
    const { src } = this.props;
    if (nextProps.src !== src) this.setState({ status: 'LOADING' });
  }

  getStyleValue() {
    const { showAsBackground, style, src, fallbackSrc } = this.props;
    const { status } = this.state;

    if (!showAsBackground) return style;
    return Object.assign({}, style, {
      backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)), url('${
        (status === 'ERRORED' || !src) ? (fallbackSrc || DEFAULT_FALLBACK_SRC) : src
      }')`,
    });
  }

  getSrcValue() {
    const { showAsBackground, src, fallbackSrc } = this.props;
    const { status } = this.state;

    if ((status === 'LOADING' || status === 'LOADED') && !showAsBackground) return src || fallbackSrc || DEFAULT_FALLBACK_SRC;
    if (status === 'ERRORED' && !showAsBackground) return fallbackSrc || DEFAULT_FALLBACK_SRC;
    return TRANSPARENT_SRC;
  }

  handleError(...args) {
    const { onError } = this.props;
    this.setState({ status: 'ERRORED' });
    onError(...args);
  }

  handleLoad(...args) {
    const { onLoad } = this.props;
    const { status } = this.state;
    if (status !== 'ERRORED') {
      this.setState({ status: 'LOADED' });
      onLoad(...args);
    }
  }

  render() {
    const { className, onClick, onTouchEnd, alt } = this.props;
    return (
      <img
        alt={ alt }
        className={ className }
        onClick={ onClick }
        onError={ this.handleError.bind(this) }
        onLoad={ this.handleLoad.bind(this) }
        onTouchEnd={ onTouchEnd }
        src={ this.getSrcValue() }
        style={ this.getStyleValue() }
      />
    );
  }
}

ImageWithFallback.defaultProps = {
  alt: null,
  className: '',
  fallbackSrc: DEFAULT_FALLBACK_SRC,
  onClick: () => {},
  onError: () => {},
  onLoad: () => {},
  onTouchEnd: () => {},
  showAsBackground: false,
  style: {},
};

ImageWithFallback.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  fallbackSrc: PropTypes.string,
  onClick: PropTypes.func,
  onError: PropTypes.func,
  onLoad: PropTypes.func,
  onTouchEnd: PropTypes.func,
  showAsBackground: PropTypes.bool,
  src: PropTypes.string.isRequired,
  style: PropTypes.shape(),
};
